import type { RfqQueryQuota } from "../types";

export function questionsLeft(quota: RfqQueryQuota): number {
  return Math.max(0, quota.limit - quota.used);
}

export function quotaCopy(quota: RfqQueryQuota): string {
  const left = questionsLeft(quota);
  if (left > 0) return `${left} of ${quota.limit} question${quota.limit === 1 ? "" : "s"} left`;
  return quota.limit === 1 ? "Your 1 question is used" : `All ${quota.limit} questions used`;
}
